import React from 'react'
import { Radio as ReactRadio } from 'react-radio-group'

export const Radio = (props) => {
  return <ReactRadio {...props} />
}
